<template>
    <div id="XL3Container" ref="report_container" style="width:100%;height:100%">
        <Spinner v-if="loading" />
        <Dialog v-else-if="needsLogIn" @close="needsLogIn = false" size="lg" title="Please sign in to your account."
            message="By clicking the sign in button you will be taken to the XL3 account sign in page to enter your credentials.">
            <template v-slot:footer>
                <CommonButton
                    :type="ButtonType.Default"
                    :text="Localizer.Localize('Cancel_PascalCase')"
                    @click="needsLogIn = false"/>
                <CommonButton
                    :type="ButtonType.Primary"
                    :text="Localizer.Localize('Sign_In')"
                    @click="XL3LogIn"/>
            </template>
        </Dialog>
        <iframe v-else style="width:100%; height:100%; background-color:white" :src="url"></iframe>
    </div>
</template>

<script lang="ts">
import { AuthClient } from "../../api/ApiClientBase";
import * as api from "../../api/ApiClient";
import { Component, Prop, Vue } from 'vue-facing-decorator';
import Spinner from "../helpers/Spinner.vue";
import Dialog from "../helpers/Dialog.vue";
import { Localizer } from "../../api/Localizer";
import XLCubedHelper from "@/api/XLCubedHelper";
import { isEmbedded } from "@/utils/Utils";
import { isFeatureFlagEnabled } from "@/services/featureFlagService";
import CommonButton from "../helpers/CommonButton.vue";
import { ButtonType } from "../helpers/HelpersInterface";

@Component({ components: { Spinner, Dialog, CommonButton } })
export default class XL3 extends Vue {
    private loading: boolean = true;
    private needsLogIn: boolean = false;
    private url: string | null | undefined = null;
    private xlCubedHelper: XLCubedHelper | null = null;
    private Localizer = new Localizer(this.$store);
    private activeReports: string[] = []; // Track report GUIDs for cleanup
    private ButtonType = ButtonType;


    get Tenant(): api.Tenant { return this.$store.state.security.Tenant; }

    @Prop()
    private Path!: string | null;

    @Prop()
    private AdditionalUrl: string | null | undefined;

    private get ReportPath(): string {
        if (this.Path != null)
            return this.Path;
        // @ts-ignore
        return this.$route.params.pathMatch;
    }
    async mounted() {
        this.$nextTick(async () => {
            this.xlCubedHelper = new XLCubedHelper(this.$store, this.$route);
            window.addEventListener("message", (msg) => {
                if (msg.data.type === "workbook-loaded") {
                    const reportGuid = msg.data.guid;
                    if (reportGuid && !this.activeReports.includes(reportGuid)) {
                        this.activeReports.push(reportGuid);
                    }
                }
            });
            const auth_client = AuthClient.getInstance();
            await auth_client.ensureToken(true);
            if (isEmbedded()) {
                // In the Anaplan shell, XLCubed shares the same domain and authenticates
                // via Anaplan SSO cookies (same-origin). Sending a POST with UserToken
                // causes XLCubed to validate against its configured Fluence API URL,
                // which may differ per environment and is outside portal control.
                this.url = await this.xlCubedHelper.getUrl(this.ReportPath, this.Tenant.name!);
                if (this.AdditionalUrl && this.url != null) {
                    this.url += this.AdditionalUrl;
                }
            } else {
                var html = await this.xlCubedHelper.getFormHtml(this.ReportPath, this.Tenant.name!, this.AdditionalUrl || undefined);
                this.url = 'data:text/html;charset=utf-8,' + encodeURI(html);
            }
            this.loading = false;
        });
    }

    async beforeUnmount() {
        // Clear active XL3 sessions only if feature flag "PHOS-1950-unload-axl" is enabled
        if (await isFeatureFlagEnabled("PHOS-1950-unload-axl")) {
            this.clearAllActiveAXLSessions();
        }
    }

    clearAllActiveAXLSessions() {
        if (this.activeReports.length > 0) {
            try {
                if (this.xlCubedHelper) {
                    this.xlCubedHelper.getDeallocationUrl(this.activeReports.join(",")).then(url => {
                        if (navigator.sendBeacon) {
                            navigator.sendBeacon(url);
                        } else {
                            fetch(url, { mode: 'no-cors', keepalive: true });
                        }
                        this.activeReports = []; // Clear after cleanup
                    }).catch(error => {
                        console.error('Error getting deallocation URL:', error);
                    });
                }
            } catch (error) {
                console.error('Error cleaning up XL3 sessions:', error);
            }
        }
    }

    async XL3LogIn() {
        var browserService = new BrowserService();
        var myNewTab = browserService.openNewTab();

        var a = document.createElement('a') as any;
        a.href = this.url;

        var auth_client = AuthClient.getInstance();

        browserService.updateTabLocation("https://" + a.hostname + "/.auth/login/aad?post_login_redirect_uri=https://" + a.hostname + "/WebForm/AuthPostLogin.aspx?ret=" + AuthClient.configuration.uiBaseUrl + "/close", myNewTab);

        var y = setInterval(x => {
            if (myNewTab?.location.href == AuthClient.configuration.uiBaseUrl + "/close") {
                console.log("new tab was used to log user in");
                clearInterval(y);
                myNewTab.close();

                this.loading = false;
                this.needsLogIn = false;
            }
        }, 2500);
    }
}

class BrowserService {
    public openNewTab() {
        var newTabWindow = window.open();
        return newTabWindow;
    }
    public updateTabLocation(tabLocation: string, tab: Window | null) {
        if (tab != null) {
            if (!tabLocation) {
                tab.close();
            }
            tab.location.href = tabLocation;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
